var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-group',[_c('label',{staticClass:"mb-1 text-lg d-flex align-items-center"},[_vm._v(" Email ")]),_c('b-input',{attrs:{"type":"text","placeholder":"Nhập email..."},model:{value:(_vm.entry.email),callback:function ($$v) {_vm.$set(_vm.entry, "email", $$v)},expression:"entry.email"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }